import { useTranslation } from "react-i18next";
import { Header } from "../../components/layout/Header";
import { OrganizationCard } from "../../components/organizations/OrganizationCard";
import { LoadingSkeleton, LinkButton } from "../../components/common";
import { useAuth } from "../../hooks/useAuth";
import styles from "./OrganizationListPage.module.css";

export default function OrganizationListPage() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const organizations = user?.organizations ?? [];

  if (loading) {
    return (
      <>
        <Header />
        <div className="container">
          <div className={styles.pageHeader}>
            <h1>{t("organizations.title")}</h1>
          </div>
          <LoadingSkeleton type="card" count={3} />
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className={styles.pageHeader}>
          <h1>{t("organizations.title")}</h1>
          <LinkButton to="/organizations/create" variant="primary">
            {t("organizations.createButton")}
          </LinkButton>
        </div>

        {organizations.length === 0 ? (
          <div className={styles.emptyState}>
            <p>{t("organizations.noOrganizations")}</p>
            <LinkButton to="/organizations/create" variant="primary">
              {t("organizations.createFirstButton")}
            </LinkButton>
          </div>
        ) : (
          <div className={styles.organizationGrid}>
            {organizations.map((org) => (
              <OrganizationCard key={org.id} organization={org} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
